export default __webpack_public_path__ + "static/media/SampleViewCardBalance.9afa5c4c.csv";